import axios from "axios";

const instance = axios.create({
    baseURL: (process.env.NODE_ENV==='production' && !window.location.hostname.includes('192.168'))?process.env.REACT_APP_API_PROD:process.env.REACT_APP_API_PROD,
})

export default instance;